import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'fidelitySingleGroup',
    label: 'Fidelity Single Group Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
